import cacheManagementHttp from './cacheManagementHttp';

const getCache = (context) => {
  return new Promise((resolve, reject) => {
    cacheManagementHttp.getCache(context)
      .then(data => {
        const response = data.body;
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const deleteCacheElements = (context, ids) => {
  return new Promise((resolve, reject) => {
    cacheManagementHttp.deleteCache(context, ids.join()).then(response => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

export default {
  getCache,
  deleteCacheElements
};



// WEBPACK FOOTER //
// ./src/api/cacheManagement/index.js